<template>
  <div >
    <div class="d-flex justify-content-center mb-3">
      <b-spinner :label="description"></b-spinner>
    </div>

 </div>
</template>

<script>

export default {
  name: 'LoaderComponent',
  data () {
    return {
      value: 100,
      description: "Waiting for data..."
    }
  },
  computed:{

  }
}
</script>


<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/shared/LoaderComponent.vue